import { render } from "./PeerInfo.vue?vue&type=template&id=157bf6c4"
import script from "./PeerInfo.vue?vue&type=script&lang=js"
export * from "./PeerInfo.vue?vue&type=script&lang=js"

import "./PeerInfo.vue?vue&type=style&index=0&id=157bf6c4&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__